import React, { useEffect, useRef, useState } from 'react'
import './wheel.less'
import WheelBgWaiQuan from '../../assets/bg_waiquan.webp'
import WheelBgNeiQuan from '../../assets/bg_neiquan.webp'
import WheelAnniu from '../../assets/bg_anniu.webp'
import WheelQuanzhuangshi from '../../assets/bg_quanzhuangshi.webp'

import itemSacar from '../../assets/bg_qb_1.png'
import itemFailed from '../../assets/bg_k.webp'
import itemMoney from '../../assets/bg_q.webp'
import itemGold from '../../assets/bg_jb.png'
import itemSelect from '../../assets/bg_guangquan.webp'
import SpinUI from '@/componentsUI/Spin'
import classNames from 'classnames'

export interface WheelProps {
    rotateInfo: {
        index: number,
        start: boolean
    }
    className?: string,
    timesNumber?: number,
    onClickRotate?: () => void,
    onFinishCallback?: (data: any) => void,
    isLogin: boolean,
    isLoading: boolean
}

const Wheel = ({ isLoading, rotateInfo, className, timesNumber = 0, onClickRotate, onFinishCallback, isLogin }: WheelProps) => {

    const [angle, setAngle] = useState({
        value: 0
    })

    const [running, setRuning] = useState(false)

    const selectFlashingRef = useRef(null)

    //const fixedOffset = 2;
    const currentRef = useRef({
        currentAngle: 0,
        currentIndex: 0
    })

    useEffect(() => {
        if (rotateInfo && rotateInfo.start) {
            const degressPerSection = 360 / 6;
            const extraRotations = 5;
            let targetIndex = rotateInfo.index - currentRef.current.currentIndex;
            if (targetIndex < 0) {
                targetIndex = targetIndex + 6;
            }
            currentRef.current.currentIndex = rotateInfo.index;
            const finalAngle = extraRotations * 360 + targetIndex * degressPerSection + currentRef.current.currentAngle;
            currentRef.current.currentAngle = finalAngle % 360
            setAngle({
                value: finalAngle
            });
            setRuning(true)
            //console.log("目标=====", rotateInfo.index)
        }
    }, [rotateInfo])

    // const wheelStyle = {
    //     transform: `rotate(${angle}deg)`,
    //     transition: `transform 4s cubic-bezier(0.33, 1, 0.68, 1)`
    // }

    const wheelRef = useRef(null)

    useEffect(() => {
        if (!rotateInfo || !rotateInfo.start) {
            return
        }
        wheelRef.current.style.transform = `rotate(${angle.value}deg)`
        wheelRef.current.style.transition = `transform 4s cubic-bezier(0.33, 1, 0.68, 1)`
        const handleAnimationEnd = () => {
            wheelRef.current.style.transform = `rotate(${angle.value % 360}deg)`
            wheelRef.current.style.transition = `none`
            setRuning(false)

            const colors = [
                '#24f6fc',
                '#24f6fc',
                '#957eff',
                '#f269ab',
                '#ffd585',
                '#ffd291',
            ]
            selectFlashingRef.current.style.filter = `drop-shadow(133px 0px ${colors[rotateInfo.index]})`
            selectFlashingRef.current.style.animationName = 'wheel-flashing'
            setTimeout(() => {
                onFinishCallback && onFinishCallback(rotateInfo)
            }, 1000)
        }
        wheelRef.current.addEventListener('transitionend', handleAnimationEnd)
        return () => {
            wheelRef.current?.removeEventListener('transitionend', handleAnimationEnd)
        }
    }, [angle, rotateInfo])



    return (
        <div className={`share-wheel ${className}`}>
            <div className='waiquan'>
                <img src={WheelBgWaiQuan}></img>
            </div>

            <div className='wheel-content' ref={wheelRef}>
                <div className='neiquan'>
                    <img src={WheelBgNeiQuan}></img>
                </div>
                {/* 0 */}
                <div className='spin-item spin-item-rotate-0'>
                    <div className='item-content item-1'>
                        <img src={itemSacar}></img>
                    </div>
                </div>
                {/* 5 */}
                <div className='spin-item spin-item-rotate-60'>
                    <div className='item-content item-3'>
                        <img src={itemGold}></img>
                        {/* <span>x100</span> */}
                    </div>
                </div>
                {/* 4 */}
                <div className='spin-item spin-item-rotate-120'>
                    <div className='item-content item-2'>
                        <img src={itemMoney}></img>
                        {/* <span>x100</span> */}
                    </div>
                </div>
                {/* 3 */}
                <div className='spin-item spin-item-rotate-180'>
                    <div className='item-content item-4'>
                        <img src={itemFailed}></img>
                    </div>
                </div>
                {/* 2 */}
                <div className='spin-item spin-item-rotate-240'>
                    <div className='item-content item-5'>
                        <img src={itemGold}></img>
                        {/* <span>x100</span> */}
                    </div>
                </div>
                {/* 1 */}
                <div className='spin-item spin-item-rotate-300'>
                    <div className='item-content item-2'>
                        <img src={itemMoney}></img>
                        {/* <span>x100</span> */}
                    </div>
                </div>
            </div>

            <div className={classNames('select-point', {
                'select-point-hidden': running,
            })}>
                <img ref={selectFlashingRef} src={itemSelect} className={running ? '' : 'select-animation-play'}></img>
            </div>
            {/* <div className='quan-zhuang-shi'> */}
            {/*     <img src={WheelQuanzhuangshi} alt="" /> */}
            {/* </div> */}
            <div className='wheel-point' onClick={onClickRotate}>
                <div className={`point ${running ? 'point-animation-stop' : ''}`}>
                    <img src={WheelAnniu}></img>
                    {
                        isLoading ? <SpinUI
                            className='wheel-point-loading-spin'
                            dot block loading={true} /> : <span className='times'>{isLogin ? timesNumber : 1}</span>
                    }

                </div>
            </div>

        </div>
    )
}


export default Wheel
